import { genExam } from '../examType'

const checkExamNotFree = (user, data) => (user.isPackageFree && data?.examType !== 'free' && data?.isFree !== true)

export const validateAndEnterExam = (user, props, data) => {
  // console.log('checkExamNotFree = ', checkExamNotFree(user, data))
  if (!user) { // ไม่ใช่ user ให้ login ก่อน
    return window.location.href = '/login'
  } else if (checkExamNotFree(user, data)) {
    // props.props.history.push('/profile/store')
  } else {
    return genExam(user, props, data).enterExam
  }
}